import React, { Component } from 'react';

class AboutPage extends Component {

  render() {
    return <p>hello about</p>
  }
}

export default AboutPage;